import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from '../../common/Model';
export default class ExtensionReadme extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "content", Model.attribute('content'));
  }
}
flarum.reg.add('core', 'admin/models/ExtensionReadme', ExtensionReadme);